/**
 * Shared style definitions for dropdown root components (Select, Combobox).
 * Trigger/input styles stay separate — they use different CSS variable prefixes
 * and focus selectors.
 */

/** Root variants shared by <e-select> and <e-combobox> */
export const dropdownRootConfig = {
  base: `relative inline-flex`,
  variants: {
    disabled: {
      true: `opacity-50 cursor-not-allowed!`,
      false: ``,
    },
    block: {
      true: `w-full`,
      false: ``,
    },
  },
  defaults: {
    disabled: false,
    block: false,
  },
};

/** Content variants shared by <e-select-content> and <e-combobox-content> */
export const dropdownContentConfig = {
  base: `
    min-w-[160px]
    max-h-[300px]
    overflow-y-auto
  `,
  variants: {
    size: {
      xs: ``,
      sm: ``,
      md: ``,
      lg: ``,
      xl: ``,
    },
  },
  defaults: {
    size: "md" as const,
  },
};

/** Group variants shared by <e-select-group> and <e-combobox-group> */
export const dropdownGroupConfig = {
  base: ``,
  variants: {},
  defaults: {},
};
